interface NetworkShieldProps {
  className?: string;
  color?: string;
}

export default function NetworkShield({ className = '', color = '#06B6D4' }: NetworkShieldProps) {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M20 3L7 8.5V18.5C7 27.25 13.05 35.35 20 37C26.95 35.35 33 27.25 33 18.5V8.5L20 3Z'
        fill={color}
        fillOpacity='0.15'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <rect x='14' y='19' width='2.5' height='4' rx='1' fill={color} />
      <rect x='18.75' y='16' width='2.5' height='7' rx='1' fill={color} />
      <rect x='23.5' y='13' width='2.5' height='10' rx='1' fill={color} />
    </svg>
  );
}
